<template>
<div v-if="job">


  <div class="box">
    <div class="flex flex-wrap">
      <div class="w-full md:w-1/2">
        <img class="h-10" :src="!config.logoPrintPath || url.resolve(config.URL.API.host, config.logoPrintPath)">
      </div>
      <div class="w-full md:w-1/2 md:text-right">
        <div class="flex items-center justify-end">
          <p class="text-2xl font-bold">
            Remarks
          </p>
        </div>
      </div>
    </div>


    <div class="flex flex-wrap">
      <div class="w-full md:w-8/12" v-if="job.contact">
        <div class="mt-3 pb-3 border-b border-theme-200 light:border-theme-600">
          <a class="text-link" @click.stop="$router.push($contactPageByType(job.contact, 'details'))">
            <span class="mb-0 text-lg">
              {{ job.contact.first_name }} {{ job.contact.last_name }}
              <template v-if="job.contact.company_name"> ({{ job.contact.company_name }})</template>
              <small>#{{ job.contact.id }}</small>
            </span>
          </a>
          <p v-if="job && job.vehicle">
            {{ job.vehicle.make }} {{ job.vehicle.model }}
          </p>
        </div>

      </div>

      <div class="w-full md:w-4/12 flex flex-col">
        <div class="self-end pb-3 border-b border-theme-200 light:border-theme-600 text-sm">
          <table>
            <tbody>
              <tr>
                <td>Job:</td>
                <td colspan="2" class="font-bold text-lg text-right">#{{ job.id }}</td>
              </tr>
              <tr>
                <td>Date:</td>
                <td class="text-right">
                  {{ $moment(job.created_at).format(config.dateFormats.display) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="text-sm text-right mt-2">
          <p class="text-base font-bold">{{ config.companyName }}</p>
          <p>{{ config.companyAddress }}, {{ config.companyCity }}</p>
          <p v-if="config.companyState">{{ config.companyState }}, </p>
          <p>{{ config.companyPostCode }}, {{ config.companyCountry }}</p>
          <p>{{ config.companyPhone }}</p>
          <p v-if="config.companyVATNumber"><strong>VAT:</strong> {{ config.companyVATNumber }}</p>
        </div>
      </div>
    </div>

    <p class="text-lg text-center my-12" v-if="!remarks.list.length && !editor.active">No data to display</p>
    <div class="w-full overflow-x-auto" v-else>
      <table class="table table-striped">
        <thead>
          <tr>
            <th style="width: 5%"></th>
            <th>Description</th>
            <th style="width: 25%">Comment</th>
            <th class="d-print-none" style="width: 15%">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(re, i) in remarks.list" :key="'remarks-' + i">
            <template v-if="remarksEditIndex === null || i < remarksEditIndex">
              <td class="font-bold">{{ i + 1 }}</td>
              <td>{{ re.description }}</td>

              <td v-if="!isIcon(re.comment)">{{ re.comment }}</td>
              <td v-else>
                <div class="btn text-xs">
                  <i :class="['fas', re.comment.substring(1, re.comment.length - 1)]"></i>
                </div>
              </td>

              <td class="text-center">
                <div class="flex">
                  <button type="button" class="btn btn-blue text-xs py-2 px-3" @click="edit(i)">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button type="button" class="btn btn-red text-xs py-2 px-3 ml-2" @click="remove(i)">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </td>
            </template>
          </tr>

          <ValidationObserver
            tag="tr"
            ref="observer"
            v-slot="{ invalid }"
            v-if="editor.active"
          >
            <td></td>
            <td>
              <ValidationProvider
                rules="required"
                name="description"
                v-slot="{ errors }"
              >
                <input
                  name="description"
                  type="text"
                  id="description"
                  class="form-control"
                  v-model="editor.data.description"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
            <td>
              <template v-if="editor.commentType === 'text'">
                <div class="btn text-xs float-right cursor-pointer" @click="editor.commentType = ''"><i class="fas fa-times"></i></div>
                <ValidationProvider
                  rules="required"
                  name="comment"
                  v-slot="{ errors }"
                >
                  <input
                    autofocus
                    name="comment"
                    type="text"
                    id="comment"
                    class="form-control"
                    autocomplete="off"
                    v-model="editor.data.comment"
                  >
                  <span class="text-sm text-red-500">{{ errors[0] }}</span>
                </ValidationProvider>
              </template>
              <div v-else>
                <button
                  v-for="(icon, i) in commentTypeIcons"
                  :key="'commentTypeIcons-' + i"
                  type="button"
                  class="btn text-xs"
                  :class="{'btn-green': editor.commentType === icon}"
                  @click="editor.commentType = icon">
                  <i :class="['fas', icon]"></i>
                </button>
                <button
                  type="button"
                  class="btn text-xs"
                  :class="{'btn-green': editor.commentType === 'text'}"
                  @click="editor.commentType = 'text'">
                  <i class="fas fa-font"></i>
                </button>
              </div>
            </td>
            <td class="text-center">
              <div class="flex">
                <button type="button" class="btn btn-green text-xs" @click="save">
                  <i class="fas fa-check"></i>
                </button>
                <button type="button" class="btn btn-red text-xs ml-2" @click="close">
                  <i :class="['fas', remarksEditIndex !== null ? 'fa-undo' : 'fa-times']"></i>
                </button>
              </div>
            </td>
          </ValidationObserver>

          <!-- only when editing - FML -->
          <tr v-for="(re, i) in remarks.list" :key="'remarks-continue-' + i">
            <template v-if="remarksEditIndex !== null && i > remarksEditIndex">
              <td class="font-bold">{{ i + 1 }}</td>
              <td>{{ re.description }}</td>

              <td v-if="!isIcon(re.comment)">{{ re.comment }}</td>
              <td v-else>
                <div class="btn text-xs">
                  <i :class="['fas', re.comment.substring(1, re.comment.length - 1)]"></i>
                </div>
              </td>

              <td class="text-center">
                <div class="flex">
                  <button type="button" class="btn btn-blue text-xs py-2 px-3" @click="edit(i)">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button type="button" class="btn btn-red text-xs py-2 px-3 ml-2" @click="remove(i)">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </td>
            </template>
          </tr>

        </tbody>
      </table>
    </div>

    <div class="flex mt-4">
      <div
        v-if="!editor.active"
        class="btn btn-purple text-sm mr-2 h-10 flex items-center px-3 mb-1"
        @click="editor.active = true"
      >
        <i class="fas fa-plus"></i>
        <span class="ml-2">New remark</span>
      </div>
    </div>

    <div class="mt-4">
      <label for="note">Note</label>
      <textarea
        name="note"
        class="form-control"
        id="note"
        rows="6"
        v-model="extraNoteEdit"
      ></textarea>
    </div>
    <div class="flex">
      <div
        v-if="extraNoteEdited"
        class="btn btn-blue text-sm mr-2 h-10 flex items-center px-3 mb-1"
        @click="saveExtraNote"
      >
        <i class="fas fa-check"></i>
        <span class="ml-2">Save note</span>
      </div>
    </div>
  </div>

  <div class="box mt-4">
    <div class="flex flex-wrap flex-col">
      <div class="self-end text-right">
        <div class="btn px-3 py-2 btn-blue ml-3" @click="print">
          <i class="fas fa-print"></i>
          <span class="ml-2">Print</span>
        </div>
      </div>
    </div>
  </div>

</div>
</template>


<script>
import axios from 'axios'
import url from 'url'
import { mapGetters } from 'vuex'

var pdfMake = require('pdfmake/build/pdfmake.js')
var pdfFonts = require('pdfmake/build/vfs_fonts.js')
pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  props: {
    job: {}
  },
  data() {
    return {
      url,
      remarks: {
        extraNote: null,
        list: [],
      },
      extraNoteEdit: null,
      remarksEditIndex: null,
      commentTypeIcons: ['fa-check', 'fa-times'],
      editor: {
        active: false,
        data: {
          description: '',
          comment: '',
        },
        commentType: ''
      }
    }
  },
  computed: {
    extraNoteEdited() {
      return this.extraNoteEdit !== this.remarks.extraNote
    },
    ...mapGetters({
      config: 'config/config',
    })
  },
  watch: {
    'job.remarks'() {
      this.set()
    }
  },
  mounted() {
    this.set()
  },
  methods: {
    isIcon(string) {
      return !string ? false : string[0] === ':' && string[string.length - 1] === ':'
    },
    set() {
      if (this.job.remarks) {
        this.remarks = this.job.remarks
        if (this.job.remarks.extraNote) {
          this.extraNoteEdit = this.job.remarks.extraNote
        } else {
          this.remarks.extraNote = null
        }
      }
    },
    edit(index) {
      this.remarksEditIndex = index
      this.editor.data.description = this.remarks.list[index].description
      this.editor.data.comment = this.remarks.list[index].comment

      if (this.isIcon(this.editor.data.comment)) {
        let icon = this.editor.data.comment.substring(1, this.editor.data.comment.length - 1)
        if (this.commentTypeIcons.indexOf(icon) !== -1) {
          this.editor.data.comment = ''
          this.editor.commentType = icon
        }
      } else if (this.editor.data.comment !== '') {
        this.editor.commentType = 'text'
      }

      this.editor.active = true
    },
    saveExtraNote() {
      this.remarks.extraNote = this.extraNoteEdit
      this.$emit('updated', this.remarks)
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      // add colon if icon
      // can also do this in HTML directly
      if (this.editor.commentType !== '' && this.editor.commentType !== 'text') {
        this.editor.data.comment = ':' + this.editor.commentType + ':'
      }
      if (this.remarksEditIndex === null) {
        // create
        this.remarks.list.push(Object.assign({}, this.editor.data))
      } else {
        // edit
        this.remarks.list[this.remarksEditIndex].description = this.editor.data.description
        this.remarks.list[this.remarksEditIndex].comment = this.editor.data.comment
      }

      this.close()
      this.$emit('updated', this.remarks)
    },
    close() {
      this.remarksEditIndex = null
      this.editor.data.description = ''
      this.editor.data.comment = ''
      this.editor.commentType = ''
      this.editor.active = false
    },
    remove(index) {
      this.remarks.list.splice(index, 1)
      this.$emit('updated', this.remarks)
    },

    print() {
      // we could store logodata in data()
      // however loading the logo on each print request ensures latest logo usage
      this.pdfLogoData()
        .then((data) => {
          this._print(data)
        })
    },
    _print(pdfLogoData) {
      this.editor.active = false


      let rows = []
      rows.push([
        {text: '#', bold: true},
        {text: 'Description', bold: true},
        {text: 'Comment', bold: true},
      ])

      for (let i in this.remarks.list) {
        let item = this.remarks.list[i]
        rows.push([
          +i + 1,
          item.description,
          this.$options.filters.commentPDFDisplay(item.comment),
        ])
      }

      let companyVATText = [
        { text: '\nVAT: ', fontSize: 9, bold: true },
        { text: this.config.companyVATNumber, fontSize: 9 },
      ]

      var docDefinition = {
        content: [
          {
            columns: [
              {
                width: 90,
                image: pdfLogoData,
              },
              {
                width: '*',
                text: '',
              },
              {
                width: '25%',
                text: 'Remarks',
                fontSize: 20,
                bold: true,
                alignment: 'right'
              }
            ],
          },
          {
            columns: [
              {
                width: '*',
                text: '',
              },
              {
                width: '25%',
                text: [
                  'Job: #' + this.job.id + '\n' + 'Date: ',
                  this.$moment(this.job.created_at).format(this.config.dateFormats.display),
                ],
                alignment: 'right'
              }
            ],
            margin: [ 0, 0, 0, 30 ],
          },
          {
            columns: [
              {
                text: [
                  {text: this.job.contact.first_name + ' ' + this.job.contact.last_name + (this.job.contact.company_name ? ' ' + this.job.contact.$ : ''), bold: true, fontSize: 12},
                  (this.job && this.job.vehicle ? '\n' + this.job.vehicle.make + ' ' + this.job.vehicle.model : ''),
                ]
              },
              {
                width: '*',
                text: '',
              },
            ],
          },
          {
            canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515 - 25*515/100, y2: 0, lineWidth: 1 } ],
            margin: [ 0, 5, 0, 5 ]
          },
          {
            columns: [
              {
                width: '*',
                text: '',
              },
              {
                width: '25%',
                text: [
                  { text: this.config.companyName + '\n', bold: true, fontSize: 10 },
                  { text: this.config.companyAddress + ' ' + this.config.companyCity + '\n', fontSize: 9 },
                  { text: (this.config.companyState ? this.config.companyState + ', ' : '') + ' ' + this.config.companyPostCode + ' ' + this.config.companyCountry + '\n', fontSize: 9 },
                  { text: this.config.companyPhone, fontSize: 9 },
                  ...this.config.companyVATNumber ? companyVATText : []
                ],
                alignment: 'right'
              }
            ],
            columnGap: 10
          },
          {
            canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ],
            margin: [ 0, 15, 0, 5 ]
          },
          {
            layout: 'lightHorizontalLines',
            table: {
              headerRows: 1,
              widths: ['20%', '50%', '30%'],
              body: [
                ...rows,
              ]
            },
            // left, top, right, bottom
            margin: [ 0, 20, 0, 20 ],
          },
          {
            columns: [
              {
                width: '35%',
                layout: {
                  hLineWidth(i, node) {
                    return (i === 1 || i === node.table.widths.length) ? 1 : 0
                  },
                  vLineWidth() {
                    return 0
                  },
                  hLineStyle: function () {
                    return {dash: {length: 5, space: 3}}
                  },
                  paddingLeft() { return 0 },
                  paddingRight() { return 10 },
                  paddingTop() { return 10 },
                  paddingBottom() { return 30 },
                },
                table: {
                  headerRows: 0,
                  widths: ['*'],
                  body: [
                    ['Issuer\'s signature'],
                  ],
                }
              },
              {
                width: '*',
                text: ''
              },
              {
                width: '35%',
                layout: {
                  hLineWidth(i, node) {
                    return (i === 1 || i === node.table.widths.length) ? 1 : 0
                  },
                  vLineWidth() {
                    return 0
                  },
                  hLineStyle: function () {
                    return {dash: {length: 5, space: 3}}
                  },
                  paddingLeft() { return 0 },
                  paddingRight() { return 10 },
                  paddingTop() { return 10 },
                  paddingBottom() { return 30 },
                },
                table: {
                  headerRows: 0,
                  widths: ['*'],
                  body: [
                    ['Receiver\'s signature'],
                  ],
                }
              },
            ],
          },
        ],
        footer(currentPage, pageCount) {
          if (pageCount === currentPage) {
            return {
              text: 'Thank you for doing business with us',
              alignment: 'center',
            }
          }
        },
        pageSize: 'A4',
        defaultStyle: {
          fontSize: 9,
          // bold: true
        }
      }

      pdfMake.createPdf(docDefinition).open()
    },
    pdfLogoData() {
      return axios.get(this.config.logoPrintPath + '?_', {
        responseType: 'arraybuffer'
      })
        .then(response => {
          let image = btoa(
            new Uint8Array(response.data)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          )
          return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`
        })
    },
  },
  filters: {
    commentPDFDisplay(comment) {
      if (comment === ':fa-times:') {
        return 'x'
        // return '✗' // does not work with pdfmake without new font
      }
      if (comment === ':fa-check:') {
        return '√'
        // return '✓' // does not work with pdfmake without new font
      }
      return comment
    }
  }
}
</script>
